export function splitName(fullName?: string | null) {
  if (!fullName) {
    return {
      firstName: '',
      lastName: '',
    };
  }

  const parts = fullName.trim().split(/\s+/);

  return {
    firstName: parts[0] || '',
    lastName: parts.slice(1).join(' ') || '',
  };
}
